import { createRouter, createWebHistory } from 'vue-router';
const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Home.vue'),
        meta: {
            title: '首页',
        },
    },
    {
        path: '/tournaments',
        name: 'Tournaments',
        component: () => import('@/views/tournaments/TournamentList.vue'),
        meta: {
            title: '赛事列表',
        },
    },
    {
        path: '/tournaments/create',
        name: 'CreateTournament',
        component: () => import('@/views/tournaments/CreateTournament.vue'),
        meta: {
            title: '创建赛事',
        },
    },
    {
        path: '/tournaments/:id',
        name: 'TournamentDetail',
        component: () => import('@/views/tournaments/TournamentDetail.vue'),
        meta: {
            title: '赛事详情',
        },
    },
    {
        path: '/tournaments/:id/settings',
        name: 'TournamentSettings',
        component: () => import('@/views/tournaments/TournamentSettings.vue'),
        meta: {
            title: '赛事设置',
        },
    },
    {
        path: '/tournaments/:id/players',
        name: 'TournamentPlayers',
        redirect: (to) => ({
            name: 'TournamentSettings',
            params: { id: to.params.id },
            query: { tab: 'players' }
        }),
        meta: {
            title: '赛事选手',
        },
    },
    {
        path: '/tournaments/:id/matches',
        name: 'TournamentMatches',
        redirect: (to) => ({
            name: 'TournamentSettings',
            params: { id: to.params.id },
            query: { tab: 'matches' }
        }),
        meta: {
            title: '比赛场次',
        },
    },
    {
        path: '/tournaments/:tournamentId/matches/:id/referee',
        name: 'MatchReferee',
        component: () => import('@/views/matches/RefereeLiveScore.vue'),
        meta: {
            title: '裁判计分',
        },
    },
    {
        path: '/tournaments/:tournamentId/matches/:id/screen',
        name: 'MatchScreen',
        component: () => import('@/views/matches/MatchScreen.vue'),
        meta: {
            title: '比分大屏',
        },
    },
    {
        path: '/venues/:venueId/screen',
        name: 'VenueScreen',
        component: () => import('@/views/venues/VenueScreen.vue'),
        meta: {
            title: '场地大屏',
        },
    },
    {
        path: '/players',
        name: 'Players',
        component: () => import('@/views/players/PlayerList.vue'),
        meta: {
            title: '选手管理',
        },
    },
    {
        path: '/players/create',
        name: 'CreatePlayer',
        component: () => import('@/views/players/CreatePlayer.vue'),
        meta: {
            title: '添加选手',
        },
    },
    {
        path: '/players/:id',
        name: 'PlayerDetail',
        component: () => import('@/views/players/PlayerDetail.vue'),
        meta: {
            title: '选手详情',
        },
    },
    {
        path: '/venues',
        name: 'VenueManagement',
        component: () => import('@/views/venues/VenueManagement.vue'),
        meta: {
            title: '场地管理',
        },
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/auth/Login.vue'),
        meta: {
            title: '登录',
        },
    },
    {
        path: '/access-denied',
        name: 'AccessDenied',
        component: () => import('@/views/auth/AccessDenied.vue'),
        meta: {
            title: '访问被拒绝',
        },
    },
    // 404页面
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('@/views/errors/NotFound.vue'),
        meta: {
            title: '页面未找到',
        },
    },
];
const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        else {
            return { top: 0 };
        }
    },
});
// 路由守卫
router.beforeEach(async (to, from, next) => {
    // 设置页面标题
    if (to.meta?.title) {
        document.title = `${to.meta.title} - 个性化赛事系统`;
    }
    // 公开路由，无需权限检查
    const publicRoutes = ['Login', 'AccessDenied', 'NotFound'];
    if (publicRoutes.includes(to.name)) {
        next();
        return;
    }
    // 大屏和裁判页面，允许访问
    const allowedScreenRoutes = ['MatchScreen', 'VenueScreen', 'MatchReferee'];
    if (allowedScreenRoutes.includes(to.name)) {
        next();
        return;
    }
    // 检查用户权限
    const { useAuthStore } = await import('@/stores/auth');
    const authStore = useAuthStore();
    try {
        // 检查认证状态
        if (!authStore.isAuthenticated) {
            await authStore.checkAuth();
        }
        // 如果用户未认证，跳转到登录页面
        if (!authStore.isAuthenticated) {
            next('/login');
            return;
        }
        // 如果用户没有访问系统的权限，跳转到访问被拒绝页面
        if (!authStore.canAccessSystem) {
            next('/access-denied');
            return;
        }
        next();
    }
    catch (error) {
        console.error('路由守卫检查失败:', error);
        next('/login');
    }
});
export default router;
